import type {
  GetApiV1ThreeLetterCodePartnerAdminsBankAccounts200One,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200,
} from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import {
  useGetPartnerAdminsBankAccounts,
  useGetPartnerAdminsUser,
  useGetPartnerAdminsUserProfile,
} from '~/hooks';

type IUseUserDetailProfileBankAccount = (userId: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
    profileData: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200;
    bankAccountData: GetApiV1ThreeLetterCodePartnerAdminsBankAccounts200One | undefined;
  };
};

/**
 * 利用者詳細プロフィール（BankAccount）のコンポーネントフック
 *
 * @param userId - 利用者ID
 */
export const useUserDetailProfileBankAccount: IUseUserDetailProfileBankAccount = userId => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsUser({ threeLetterCode, userId });
  const { data: profileData } = useGetPartnerAdminsUserProfile({ threeLetterCode, userId });
  const { data: bankAccountData } = useGetPartnerAdminsBankAccounts({
    threeLetterCode,
    userIds: [userId],
  });

  return {
    state: {
      data,
      profileData,
      bankAccountData,
    },
  };
};
